import { useState } from 'react'
import { LockKeyhole, LogIn } from 'lucide-react'
import { login } from '../lib/api'

export default function LoginView() {
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const submit = async (event) => {
    event.preventDefault()
    if (!password.trim()) return

    setLoading(true)
    setError('')
    try {
      await login(password)
      window.location.assign(safeNextPath())
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="login-shell">
      <form className="login-panel" onSubmit={submit}>
        <div className="login-icon">
          <LockKeyhole size={22} strokeWidth={1.5} />
        </div>
        <h1>Wiedersehen</h1>
        <label className="form-label" htmlFor="app-password">Passwort</label>
        <input
          id="app-password"
          className="form-input"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoFocus
        />
        {error && <div className="notice notice-error login-error">{error}</div>}
        <button className="btn btn-primary login-submit" type="submit" disabled={loading}>
          {loading ? <span className="spinner" /> : <LogIn size={14} />}
          Anmelden
        </button>
      </form>
    </main>
  )
}

function safeNextPath() {
  const requested = new URLSearchParams(window.location.search).get('next') || '/'
  if (!requested.startsWith('/') || requested.startsWith('//')) return '/'
  if (requested.startsWith('/login')) return '/'
  return requested
}
